import './index.css'

import { AnimatePresence, motion } from 'framer-motion'
import { type ComponentType, useEffect } from 'react'

import DemoHost from '@/components/DemoHost'
import { GrainOverlay } from '@/components/GrainOverlay'
import { Narrator } from '@/components/Narrator'
import { Sidebar } from '@/components/Sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AppProvider, type TabKey, useApp } from '@/context'
import { seedIfEmpty } from '@/db/seed'
import Catalog from '@/screens/Catalog'
import Clienti from '@/screens/Clienti'
import Comenzi from '@/screens/Comenzi'
import Facturare from '@/screens/Facturare'
import Flota from '@/screens/Flota'
import Mesaje from '@/screens/Mesaje'
import Panou from '@/screens/Panou'
import Rapoarte from '@/screens/Rapoarte'

// Screen registry — foundation owns this mapping. Feature agents only replace
// the body of their own screen file, keeping its default export.
const SCREENS: Record<TabKey, ComponentType> = {
  panou: Panou,
  mesaje: Mesaje,
  comenzi: Comenzi,
  clienti: Clienti,
  catalog: Catalog,
  flota: Flota,
  facturare: Facturare,
  rapoarte: Rapoarte,
}

function Shell() {
  const { activeTab } = useApp()
  const Screen = SCREENS[activeTab] ?? Panou
  return (
    <div className="min-h-screen lg:flex">
      <Sidebar />
      <main className="relative min-w-0 flex-1">
        <div className="mx-auto w-full max-w-[1240px] px-4 py-6 sm:px-6 lg:px-10 lg:py-9">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            >
              <Screen />
            </motion.div>
          </AnimatePresence>
        </div>
      </main>
    </div>
  )
}

export function App() {
  useEffect(() => {
    seedIfEmpty()
  }, [])

  return (
    <AppProvider>
      <TooltipProvider>
        <GrainOverlay />
        <Shell />
        <Narrator />
        <DemoHost />
      </TooltipProvider>
    </AppProvider>
  )
}
